import React, { Fragment } from 'react';
import { Link } from "react-router-dom";
import NavHelper from '../../helper/NavHelper';
import { getRecentPost, getDateInitials } from '../../helper/blogHelper';
import { getAuthor } from '../../helper/helper';
import tweets from '../../data/tweets.json';
import Slider from 'react-slick';

const settings = {
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    dots: false,
    vertical: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 3000,
    cssEase: 'linear',
    pauseOnHover: true
}
class Footer extends NavHelper {
    scrollToTop() {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
    }
    render() {
        const stickyHeader = this.state.stickyHeader ? ' d-block' : '';
        return (
            <Fragment>
                {/* Footer */}
                <footer className="bg-custom-theme section-padding footer">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-sm-6">
                                <div className="ft-box mb-md-80">
                                    <div className="ft-head">
                                        <h4 className="text-white">About Cannabis</h4>
                                    </div>
                                    <ul className="ft-about custom">
                                        <li>
                                            <i className="fas fa-map-marker-alt" />
                                            <span className="text-white">
                                                <strong>Address:</strong>
                                                <Link to="/about" className="fs-16 text-white d-block">Lorem ipsum dolor sit amet,
                                                    consectetur adipisicing elit</Link>
                                            </span>
                                        </li>
                                        <li>
                                            <i className="far fa-envelope" />
                                            <span className="text-white">
                                                <strong>Have any questions:</strong>
                                                <Link to="#" className="fs-16 text-white d-block">example@example.com</Link>
                                            </span>
                                        </li>
                                        <li>
                                            <i className="fas fa-phone-volume" />
                                            <span className="text-white">
                                                <strong>Phone No.:</strong>
                                                <Link to="#" className="fs-16 text-white d-block">(+123) 123 4567 890</Link>
                                            </span>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6">
                                <div className="ft-box mb-md-80">
                                    <div className="ft-head">
                                        <h4 className="text-white">Fresh Tweets</h4>
                                    </div>
                                    <Slider {...settings} className="custom ft-tweets ft-tweets-slider">
                                        {/* Data */}
                                        {tweets.map((item, i) => (
                                            <li key={i} className="p-relative">
                                                <i className="fab fa-twitter" />
                                                <span className="text-white">
                                                    {getAuthor(item.author).map((author, i) => (
                                                        <Link to="#" className="text-white fs-16 fw-500" key={i}>@{author.name}</Link>
                                                    ))}
                                                    {item.tweet} <strong className="d-block">10 Mins ago</strong></span>
                                            </li>
                                        ))}
                                        {/* Data */}
                                    </Slider>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6">
                                <div className="ft-box mb-xs-80">
                                    <div className="ft-head">
                                        <h4 className="text-white">Latest Updates</h4>
                                    </div>
                                    <ul className="custom ft-blog">
                                        {/* Data */}
                                        {getRecentPost().map((item, i) => (
                                            <li key={i}>
                                                <div className="post-date" dangerouslySetInnerHTML={{ __html: getDateInitials(item.postdate) }} />
                                                <div className="post-content">
                                                    <Link to={"/blog-details/" + item.id} className="text-white fs-16 fw-500">{item.title}</Link>
                                                </div>
                                            </li>
                                        ))}
                                        {/* Data */}
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-3 col-sm-6">
                                <div className="ft-box">
                                    <div className="ft-head">
                                        <h4 className="text-white">Connect With Us</h4>
                                    </div>
                                    <div className="ft-newsletter input-group mb-xl-20">
                                        <input type="email" name="#" className="form-control form-control-custom" placeholder="Your Email Address" required />
                                        <div className="append">
                                            <button type="submit"><i className="fal fa-check" /></button>
                                        </div>
                                    </div>
                                    <ul className="custom-flex ft-social-media">
                                        <li>
                                            <Link to="#" className="text-custom-white"><i className="fab fa-facebook-f" /></Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="text-custom-white"><i className="fab fa-twitter" /></Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="text-custom-white"><i className="fab fa-instagram" /></Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="text-custom-white"><i className="fab fa-linkedin" /></Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="text-custom-white"><i className="fab fa-pinterest-square" /></Link>
                                        </li>
                                        <li>
                                            <Link to="#" className="text-custom-white"><i className="fab fa-google-plus" /></Link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                        </div>
                    </div>
                </footer>
                <div className="copyright bg-theme">
                    <div className="container">
                        <div className="row">
                            <div className="col-12 text-center">
                                <p className="no-margin text-white">© 2022 <Link to="#" className="text-custom-white">Website.</Link> All
                                    Right Reserved.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                {/* end-Footer */}
                {/* Back to top */}
                <div id="back-top" className={"back-top" + stickyHeader}>
                    <Link to="#" onClick={(e) => this.scrollToTop()}><i className="fas fa-long-arrow-alt-up" /></Link>
                </div>
                {/* Footer */}
            </Fragment>
        );
    }
}

export default Footer;